/**
 * Represents a shared table component that holds the structure (columns) 
 * and data to be displayed in a table format.
 * 
 * The table structure includes a list of column keys and a mapping of 
 * column keys to column names. The data is a collection of objects 
 * representing the rows of the table.
 */
export class SharedTable {
  keys!: string[]; /** An array of keys representing the columns in the table. These keys are used to access specific fields in each data row. */
  columns!: { [key: string]: string }; /**  A mapping of column keys to column names. The keys are the properties of the data rows, and the values are the human-readable names of the columns to be displayed. */
  data!: unknown[]; /**  An array of data objects representing the rows in the table. Each object corresponds to a single row of data with key-value pairs where keys map to the columns of the table. */

   /**
   * Constructs a SharedTable instance with the given column definitions 
   * and data rows.
   * 
   * The constructor extracts the column keys from the provided column mapping
   * and initializes the table with the given structure and data.
   * 
   * @param columns A mapping of column keys to column names.
   * @param data An array of objects representing the rows in the table.
   */
  constructor(columns: { [key: string]: string }, data: unknown[]) {
    const keys = new Array<string>();
    for (const key of Object.keys(columns)) {
      keys.push(key);
    }

    this.keys = keys;
    this.columns = columns;
    this.data = data;
  }
}
